module.exports = __webpack_public_path__ + "static/img/cabinet24_8.8d8761cf.gif";